import React, {useState} from 'react';
import {FormikHelpers} from 'formik';

import resources from '@resources';
import constants from '@constants';
import utils from '@utils';
import {Form, Button, Modal} from '@components';
import {Props} from './types';
import * as handlers from './handlers';
import * as hooks from './hooks';

import './index.scss';

const Edit: React.FC<Props> = props => {
  const id = utils.pathParams.getUserId(props.location.pathname);
  const [isDeleteModal, setIsDeleteModal] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [isUpdateModal, setIsUpdateModal] = useState(false);
  const [isDowngradeModal, setIsDowngradeModal] = useState(false);

  const initialValues = {
    firstName: props.users.detail.firstName,
    lastName: props.users.detail.lastName,
    lastKana: props.users.detail.lastKana,
    firstKana: props.users.detail.firstKana,
    email: props.users.detail.email,
    phoneNumber: props.users.detail.phoneNumber,
    prefecture: props.users.detail.prefecture,
    authLevel: props.users.detail.authLevel,
    teamId: props.me.teamId,
    position: props.users.detail.position,
    organization: props.users.detail.organization,
    gender: props.users.detail.gender,
    birthyear: resources.users.getBirthValue(
      'year',
      props.users.detail.birthdate
    ),
    birthmonth: resources.users.getBirthValue(
      'month',
      props.users.detail.birthdate
    ),
    birthday: resources.users.getBirthValue(
      'day',
      props.users.detail.birthdate
    ),
  };

  hooks.useMount({...props}, props.actions);

  return (
    <div className="a__user-edit">
      <div className="b__title">
        <Button.GoBack history={props.history} />
        ユーザー編集
      </div>
      <div className="b__main">
        <div className="w__edit-field">
          <div className="w__information-field">
            <Form.User
              handleSubmit={(values: any, formikHelpers: FormikHelpers<any>) =>
                handlers.update(props, values, formikHelpers, props.actions, id)
              }
              me={props.me}
              submitText="編集する"
              users={props.users}
              initialValues={initialValues}
              update
            />
          </div>
        </div>
        <div className="w__side-buttons">
          {props.users.detail.authLevel === constants.AUTHORITIES.GENERAL ? (
            <Button.Normal
              text="管理者に変更する"
              onClick={() => {
                setIsUpdateModal(true);
              }}
              color="green"
              className="b__update"
              disabled={props.users.detail.isEmailBounced}
            />
          ) : (
            <Button.Normal
              text="一般ユーザーに変更する"
              onClick={() => {
                setIsDowngradeModal(true);
              }}
              color="green"
              className="b__update"
              disabled={
                props.users.detail.isEmailBounced ||
                props.users.detail.authLevel ===
                  constants.AUTHORITIES.SUPER_ADMIN ||
                (props.users.detail.id === props.me.id &&
                  props.users.detail.authLevel === constants.AUTHORITIES.ADMIN)
              }
            />
          )}

          <Button.Normal
            text="ユーザーを削除する"
            onClick={() => {
              setIsDeleteModal(true);
            }}
            color="red"
            className="b__delete"
            disabled={
              props.users.detail.authLevel ===
                constants.AUTHORITIES.SUPER_ADMIN ||
              (props.users.detail.id === props.me.id &&
                props.users.detail.authLevel === constants.AUTHORITIES.ADMIN)
            }
          />
        </div>
      </div>
      <Modal.Delete
        isModal={isDeleteModal}
        loading={deleteLoading}
        disabled={deleteLoading}
        title={
          props.users.detail.authLevel === constants.AUTHORITIES.ADMIN
            ? '管理者を削除'
            : 'ユーザーを削除'
        }
        handleCloseModal={setIsDeleteModal}
        message={
          props.users.detail.authLevel === constants.AUTHORITIES.ADMIN ? (
            <>
              <div>
                {`${props.users.detail.lastName}${props.users.detail.firstName}`}
                さんを管理者一覧から削除しますか？
              </div>
              <div>
                削除するとユーザー一覧から削除され、 ログインできなくなります。
              </div>
            </>
          ) : (
            <div>
              {`${props.users.detail.lastName}${props.users.detail.firstName}`}
              さんをユーザー一覧から削除しますか？
            </div>
          )
        }
        onClick={() => {
          handlers.deleteUser(props, id, props.me, setDeleteLoading);
        }}
      />
      <Modal.Delete
        isModal={isDowngradeModal}
        title="権限を変更"
        handleCloseModal={setIsDowngradeModal}
        id={props.users.detail.id}
        actions={props.actions}
        history={props.history}
        message={
          <>
            <div>
              {`${props.users.detail.lastName}${props.users.detail.firstName}`}
              さんの権限を管理者から一般ユーザーに変更しますか？
            </div>
            <div>変更すると、 ログインできなくなります。</div>
          </>
        }
        onClick={async () => {
          await handlers.downgrade(
            props.users.detail,
            setDeleteLoading,
            setIsDeleteModal,
            props.actions,
            props.history
          );
        }}
        loading={deleteLoading}
        disabled={deleteLoading}
        confirmText="変更する"
      />
      <Modal.UpdateAuthority
        isModal={isUpdateModal}
        title="権限変更"
        handleCloseModal={setIsUpdateModal}
        id={props.users.detail.id}
        email={props.users.detail.email}
        actions={props.actions}
        history={props.history}
      />
    </div>
  );
};

export default Edit;
